import React from 'react';
import { useSelector } from 'react-redux';
import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';

export const SectionItem = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Items.Show']
  );

  const dummy = Array.from({ length: 5 }, (v, i) => i);

  return (
    <section className="border rounded-2 p-3 pt-2 mb-3">
      <div
        className="fw-semibold py-2 border-bottom mb-3"
        style={{ fontSize: 13 }}
      >
        {StateLoading ? (
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
        ) : (
          'Informasi Item'
        )}
      </div>

      {StateLoading ? (
        dummy?.map((d, i) => (
          <ListHorizontal
            key={i}
            title={<SkeletonText count={1} />}
            content={<SkeletonText count={1} />}
          />
        ))
      ) : (
        <>
          <ListHorizontal title="Customer" content={data?.tenant?.name} />
          <ListHorizontal title="Kode Item" content={data?.code} />
          <ListHorizontal title="Barcode" content={data?.barcode || '-'} />
          <ListHorizontal title="Nama" content={data?.name} />
          <ListHorizontal title="Alias" content={data?.alias_name} />
          <ListHorizontal title="Kategori" content={data?.category} />
          <ListHorizontal title="Brand" content={data?.brand || '-'} />
        </>
      )}
    </section>
  );
};
